import React from 'react';

import { Spacer } from 'components';
import { classes } from 'components/utils';

import styles from './ButtonContainer.module.scss';

const ButtonContainer = ({ position = 'bottom', children }) => (
  <div className={classes(styles.buttonContainer, styles[position])}>
    {children || <Spacer length={30.75} />}
  </div>
);

export default ButtonContainer;
